import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/contacts/agreements/loading';
import { getContactQueryOptions } from '@/_pages/contacts/api-service';

export const Route = createFileRoute('/_private/contacts/_template/$id/agreements')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getContactQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Agreements',
    isFullWidth: true,
    tabKey: 'contacts/agreements',
  },
  pendingComponent: Loading,
});
